import { render, staticRenderFns } from "./ColumnInbox.vue?vue&type=template&id=75d05c66"
import script from "./ColumnInbox.vue?vue&type=script&lang=js"
export * from "./ColumnInbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports